import Api from "@/api/Api";

export default {
  updateUser(data) {
    return Api().patch("/user", data);
  },
};
